export const DEV_TOKEN_STORAGE_KEY = 'heysalad_token';
export const REFRESH_TOKEN_STORAGE_KEY = 'heysalad_refresh_token';
